import { generatePath } from "react-router-dom"

import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import { ONBOARDING_TOURS } from "@src/widgets/onboarding/types"
import { BankDetailsStepUi } from "@src/widgets/onboarding/ui/tours/AccountTopUp/BankDetailsStepUi"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"

export class WithdrawalInFiatCurrencyBankDetailsStep extends TourStepBase {
  component = BankDetailsStepUi
  name = `${ONBOARDING_TOURS.ACCOUNT_TOP_UP}_WithdrawalInFiatCurrencyBankDetailsStep`

  action() {
    return router.navigate({
      pathname: generatePath(paths.bankDetailSlug, { id: "new" }),
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      subtitle: "Step 1: Fill in bank details",
      title: "Withdrawal in Fiat Currency",
    }
  }
}
